var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "button notification-button",
          class: [
            {
              "has-badge-danger has-badge-rounded has-badge-small":
                _vm.$notifications.length > 0,
            },
          ],
          attrs: {
            name: "btnNotifications",
            "data-badge":
              _vm.$notifications.length > 0 ? _vm.$notifications.length : null,
          },
        },
        [_c("span", { staticClass: "msr msr-24px" }, [_vm._v("notifications")])]
      ),
      _c(
        "tippy",
        {
          ref: "tippyNotifications",
          attrs: {
            placement: "bottom",
            to: "btnNotifications",
            arrow: "",
            interactive: true,
            theme: `${_vm.$theme.name} bell-popover`,
            "max-width": 500,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "container p-2 is-flex is-justify-content-space-between is-align-items-center",
            },
            [
              _c("span", { staticClass: "is-size-5" }, [
                _vm._v("Notifications"),
              ]),
              _vm.$notifications.length > 0
                ? _c(
                    "a",
                    {
                      staticClass: "has-text-link is-size-7",
                      on: { click: _vm.dismissAll },
                    },
                    [_vm._v(" Dismiss all ")]
                  )
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "is-divider mb-1 mt-0" }),
          _c(
            "div",
            { staticClass: "container notification-container" },
            [
              _vm.$notifications.length === 0
                ? _c("div", { staticClass: "notification px-5 mb-0" }, [
                    _c("span", [_vm._v("No new notifications ")]),
                  ])
                : _vm._e(),
              _c(
                "transition-group",
                { attrs: { name: "notification-fade", tag: "div" } },
                _vm._l(_vm.$notifications, function (notification, index) {
                  return _c(
                    "div",
                    { key: notification.id, staticClass: "notification-row" },
                    [
                      index > 0
                        ? _c("hr", { staticClass: "notification-divider my-0" })
                        : _vm._e(),
                      notification.route
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openNotification(notification)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "notification px-5 mb-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tag is-rounded is-medium mr-3 notification-icon-tag",
                                          class: (
                                            _vm.getNotificationTag(
                                              notification.type
                                            ) || {}
                                          ).classes,
                                        },
                                        [
                                          _c("span", { staticClass: "icon" }, [
                                            _c("i", {
                                              class: _vm.getIconCss(
                                                notification.type
                                              ),
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex-grow-1 notification-body",
                                        },
                                        [
                                          _vm.getNotificationTag(
                                            notification.type
                                          )
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tag is-rounded mb-1",
                                                  class: _vm.getNotificationTag(
                                                    notification.type
                                                  ).classes,
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getNotificationTag(
                                                          notification.type
                                                        ).label
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("div", {
                                            staticClass: "notification-content",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                notification.content
                                              ),
                                            },
                                          }),
                                          notification.createdDate
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey is-block mt-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatTimeAgo(
                                                          notification.createdDate
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      notification.type !== 3
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button is-ghost is-small p-0 ml-3 notification-close",
                                              attrs: {
                                                type: "button",
                                                "aria-label": "dismiss",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.setAsRead(
                                                    notification.id,
                                                    notification.type
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "icon" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-close mdi-20px",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c("div", { staticClass: "notification px-5 mb-0" }, [
                            _c(
                              "div",
                              { staticClass: "is-flex is-align-items-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "tag is-rounded is-medium mr-3 notification-icon-tag",
                                    class: (
                                      _vm.getNotificationTag(
                                        notification.type
                                      ) || {}
                                    ).classes,
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        class: _vm.getIconCss(
                                          notification.type
                                        ),
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex-grow-1 notification-body",
                                  },
                                  [
                                    _vm.getNotificationTag(notification.type)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "tag is-rounded mb-1",
                                            class: _vm.getNotificationTag(
                                              notification.type
                                            ).classes,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getNotificationTag(
                                                    notification.type
                                                  ).label
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "notification-content",
                                      domProps: {
                                        innerHTML: _vm._s(notification.content),
                                      },
                                    }),
                                    notification.createdDate
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "is-size-7 has-text-grey is-block mt-1",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatTimeAgo(
                                                    notification.createdDate
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                notification.type !== 3 &&
                                notification.type !== 4
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-ghost is-small p-0 ml-3 notification-close",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "dismiss",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.setAsRead(
                                              notification.id,
                                              notification.type
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-close mdi-20px",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }